import { IGroup } from '@clickster/constant-definitions/dist-esm/entities/group/types';
import { API_V2 } from '../lib/axios';
import { fetchAllPaginated } from './utils/fetch-all-paginated';

const GROUPS_ENDPOINT = '/groups';

const list = async (params = {}) => {
  return fetchAllPaginated<IGroup>(API_V2, GROUPS_ENDPOINT, params);
};

const create = async (groupData: IGroup) => {
  const response = await API_V2.post<IGroup>(GROUPS_ENDPOINT, groupData);
  return response.data;
};

export const GroupsService = {
  list,
  create,
};

